export default "__VITE_ASSET__mRQm0iYW__"